// Which view a path shows, and the app's own links in the user menu. Everything is behind
// sign-in (main.tsx renders nothing until it settles).

import type { MenuLink } from "./components/UserMenu.js";
import { ABOUT_LINK_TEXT } from "./content/about.js";

export type View = "ask" | "admin" | "settings" | "about";

export function viewOf(path: string): View {
  if (path === "/admin" || path.startsWith("/admin/")) return "admin";
  if (path === "/settings") return "settings";
  if (path === "/about") return "about";
  return "ask";
}

export function menuLinks(view: View, go: (path: string) => void): MenuLink[] {
  return [{ label: ABOUT_LINK_TEXT, href: "/about", active: view === "about", onSelect: () => go("/about") }];
}
